import type { CountryCodeEnum } from '@graphcommerce/graphql-mesh'
import { CartAddressFragment } from '@graphcommerce/magento-cart/components/CartAddress/CartAddress.gql'
import { AddressMultiLine } from '../../Customer/AddressMultiLine/AddressMultiLine'
import { BillingAddressMultiLine } from '../../Customer/AddressMultiLine/BillingAddressMultiLine'

export type CartAddressMultiLineProps = Partial<CartAddressFragment> & { className?: string }

export function CartAddressMultiLine(props: CartAddressMultiLineProps) {
  const { country, region, __typename, ...addressProps } = props
  const AddressComponent =
    __typename === 'BillingCartAddress' ? BillingAddressMultiLine : AddressMultiLine
  return (
    <AddressComponent
      {...addressProps}
      country_code={country?.code as CountryCodeEnum}
      region={{ region_code: region?.code, region_id: region?.region_id, region: region?.label }}
    />
  )
}
